import React, { useEffect, useState } from 'react';

import { MijnOrganisatieListItem } from '../../models/user/mijnOrganisatieListItem';
import OrganisatieUsers from '../../components/authorization/user/OrganisatieUsers';
import InviteUser from '../../components/authorization/user/InviteUser';
import { userManagementService } from '../../services/user-management.service';
import NoActiveOrganisatieMessage from '../../components/controls/NoActiveOrganisatieMessage';

const PageMijnOrganisatie: React.FC = () => {
  // const { id } = useParams<{ id: string }>();
  const [mijnOrganisatie, setMijnOrganisatie] = useState<MijnOrganisatieListItem | null>(null);
  const [callbackKey, setCallbackKey] = useState(0); // Used to force re-fetching in OrganisatieUsers

  useEffect(() => {
    const storedOrganisatie = userManagementService.getStoredOrganisatie();
    if (storedOrganisatie) {
      setMijnOrganisatie(storedOrganisatie);
    }
  }, [callbackKey]); // Empty dependency array ensures this runs once when the component mounts

  const refetchUsers = async () => {
    setCallbackKey((prev) => prev + 1); // Trigger OrganisatieUsers to refetch data
  };

  return (
    <>
      <header className="app-header">
        <h1>Organisatie: {mijnOrganisatie?.displayName}</h1>
        <p className="header-sub-title">Overzicht van gebruikers van de organisatie {mijnOrganisatie?.displayName}.</p>
      </header>

      <div className="content text-left">
        { mijnOrganisatie && mijnOrganisatie.id ? (
          <>
            <OrganisatieUsers organisatieId={mijnOrganisatie.id} key={callbackKey} />
            <InviteUser organisatieId={mijnOrganisatie.id} callback={refetchUsers} />
          </>
        ) : (
          <NoActiveOrganisatieMessage />
        )}
      </div>
    </>
  );
};

export default PageMijnOrganisatie;